import reduceReducers from 'reduce-reducers'
import createFetchModule from '@utils/store/createFetchModule'
import { FetchActionsWith } from '@typings/generic'

export const moduleName = 'suppliersGrid'

const fetchModule = createFetchModule('@store/SuppliersGrid', 'LOAD', moduleName)

export const actionTypes = {
  ...fetchModule.actionTypes,
}

export default reduceReducers(fetchModule.reducer)

export const actions: FetchActionsWith<typeof actionTypes> = {
  ...fetchModule.actions,
}

export const selectors: Selectors = {
  ...fetchModule.selectors,
  // ... ownSelectors
}
